import * as React from 'react';

function PauseOutlinedIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <span style={{height: '21px'}}>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.0001 18.8327C5.39758 18.8327 1.66675 15.1018 1.66675 10.4993C1.66675 5.89685 5.39758 2.16602 10.0001 2.16602C14.6026 2.16602 18.3334 5.89685 18.3334 10.4993C18.3334 15.1018 14.6026 18.8327 10.0001 18.8327ZM10.0001 17.166C11.7682 17.166 13.4639 16.4636 14.7141 15.2134C15.9644 13.9632 16.6667 12.2675 16.6667 10.4993C16.6667 8.73124 15.9644 7.03555 14.7141 5.7853C13.4639 4.53506 11.7682 3.83268 10.0001 3.83268C8.23197 3.83268 6.53628 4.53506 5.28604 5.7853C4.03579 7.03555 3.33341 8.73124 3.33341 10.4993C3.33341 12.2675 4.03579 13.9632 5.28604 15.2134C6.53628 16.4636 8.23197 17.166 10.0001 17.166ZM7.50008 7.99935H12.5001V12.9993H7.50008V7.99935Z"
          fill="#021337"
        />
      </svg>
    </span>
  );
}

export default PauseOutlinedIcon;
